// AlertsConstants.js
/**
 * @module TimelineConstants
 * @requires keyMirror
 */

import keyMirror from 'keymirror';

/**
 * @const TimelineConstants
 */
export default keyMirror({
  GET_TC_DATA: null,
  GET_TC_DATA_SUCCESS: null,
  GET_TC_DATA_ERROR: null,
  SEND_ALERT_DETAILS_SUCCESS: null,
  GET_TC_TEXT_DATA_SUCCESS: null,
  REQUEST_ACCEPT_TC: null,
  SET_BACK_URL: null,
});
